/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechPcDesktopIcon16Light = forwardRef('TechPcDesktopIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8.5 1A1.5 1.5 0 0 0 7 2.5a.5.5 0 0 0 1 0 .5.5 0 0 1 .5-.5h4.75a.75.75 0 0 1 .75.75v9.5a.75.75 0 0 1-.75.75H11a.5.5 0 0 0 0 1h2.25A1.75 1.75 0 0 0 15 12.25v-9.5A1.75 1.75 0 0 0 13.25 1H8.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 6a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H7v1h1.5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1H6v-1H3a2 2 0 0 1-2-2V6Zm9 5H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1Z" })));
});
